module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[61]60.47eb2ee.woff2";